import { Button, Stack, TableCell, TableRow, Typography } from "@mui/material";

interface Props {
  request: ActiveJoinCompanyRequest;
  onRespondToRequest: (requestId: number, requestApproved: boolean) => void;
}

export function JoinCompanyRequestTableRow(props: Props) {
  const { request, onRespondToRequest } = props;
  return (
    <TableRow key={request.id}>
      <TableCell>
        <Typography variant="body1">{request.role.user.first_name}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body1">{request.role.user.last_name}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body1">{request.role.user.email}</Typography>
      </TableCell>
      <TableCell>
        <Stack direction="row" spacing={2}>
          <Button
            variant="outlined"
            onClick={() => onRespondToRequest(request.id, false)}
          >
            Reject
          </Button>
          <Button
            variant="contained"
            onClick={() => onRespondToRequest(request.id, true)}
          >
            Approve
          </Button>
        </Stack>
      </TableCell>
    </TableRow>
  );
}
